export const CLOSE_TICKER = "CLOSE_TICKER";


export const closeTicker = () => ({
  type: CLOSE_TICKER,
});
